import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MeteringPoint, MeteringPointAddress } from '@model';
import { debounceTime, distinctUntilChanged, map, Subject } from 'rxjs';
import { SubSink } from 'subsink';
import * as fromMeteringStore from '@appStore/metering-points';
import * as fromCustomerStore from '@appStore/customers';
import { Store } from '@ngrx/store';
import { containsCaseInsensitive } from '@utils/sx-utilities';
import { MeteringFilterType, MeteringType } from '@enums';

@Component({
    selector: 'app-metering-point-form',
    templateUrl: './metering-point-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MeteringPointFormComponent implements OnInit, OnDestroy {

  searchFilter: string;
  searchAdresses: boolean;
  meteringPoints: MeteringPoint[];
  meteringPointsView: MeteringPoint[];
  meteringType: MeteringType;
  existingMeteringPointIds: number[];
  selectedMeteringPoints: MeteringPoint[] = [];

  private subs = new SubSink();
  public keyUp = new Subject<any>();

  constructor(
    private meteringStore: Store<fromMeteringStore.State>,
    private customerStore: Store<fromCustomerStore.State>,
    public dialogRef: MatDialogRef<MeteringPointFormComponent>,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.subs.sink = this.keyUp
      .pipe(
        map(event => event.target.value),
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(selectedFilter => {
        this.updateView(selectedFilter);
      });
  }

  ngOnInit(): void {
    this.searchFilter = '';
    this.searchAdresses = false;
    this.meteringType = this.data.meteringType;
    this.existingMeteringPointIds = this.data.meteringPointIds;

    this.initNormalMpSubscription();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  // initNormalMpSubscription = () => {
  //   this.subs.sink = this.meteringStore.select(fromMeteringStore.getMeteringPointsWithAdresses).subscribe(mps => {
  //     this.meteringPoints = mps
  //       .filter(mp => mp.meteringType === this.meteringType && !this.existingMeteringPointIds.includes(mp.id, 0))
  //       .map(mp => ({
  //         ...mp,
  //         selected: false
  //       }));
  //     this.meteringPointsView = this.meteringPoints;

  //   });
  // };

  initNormalMpSubscription = () => {
      this.subs.sink = this.meteringStore.select(fromMeteringStore.getMeteringPointsWithAdresses).subscribe(mps => {
        
        // Load meteringPoint if customer is not white label
        this.subs.sink = this.customerStore.select(fromCustomerStore.getCustomers).subscribe(customers => {
  
          // Filter out mpIds where customer is white label
          if (customers) {
            mps = mps.filter(mp => {
              let customer = customers.find(c => c.id === mp.customerId);
              return customer ? !customer.isWhiteLabel : false;
            });
  
            this.meteringPoints = mps
              .filter(mp => mp.meteringType === this.meteringType && !this.existingMeteringPointIds.includes(mp.id, 0))
              .map(mp => ({
                ...mp,
                selected: false
            }))
          
            this.meteringPointsView = this.meteringPoints;
          }
  
        });
      });
  }

  updateView(filterString: string) {
    if (this.searchAdresses) {
      if (filterString === '') {
        this.meteringPointsView = [...this.meteringPoints];
      } else {
        this.meteringPointsView = [
          ...this.meteringPoints.filter(mp => this.foundInAdresses(mp.addresses, filterString) ||
          containsCaseInsensitive(mp.id.toString(), filterString) || mp.selected)
        ];
      }
    } else {
      if (filterString === '') {
        this.meteringPointsView = [...this.meteringPoints];
      } else {
        this.meteringPointsView = [...this.meteringPoints.filter(mp => containsCaseInsensitive(mp.name, filterString) ||
          containsCaseInsensitive(mp.id.toString(), filterString) || mp.selected)];
      }
    }
    this.changeDetectorRef.detectChanges();
  }

  setFilterType(adressFilter: boolean) {
    this.searchAdresses = adressFilter;
  }

  isAllMpsSelected(): boolean {
    return this.meteringPointsView.filter(mp => mp.selected).length === this.meteringPointsView.length;
  }

  isNonGroupMpsSelected(): boolean {
    return this.meteringPointsView.filter(mp => mp.selected).length !== 0;
  }

  selectMeteringPoint(meteringPoint: MeteringPoint) {
    meteringPoint.selected = !meteringPoint.selected;
    this.setSelectedMeteringPoint(meteringPoint.id, meteringPoint.selected, this.meteringPointsView);

    this.selectedMeteringPoints = this.meteringPointsView.filter(mp => mp.selected);
  }

  setSelectedMeteringPoint(id: number, isSelected: boolean, meteringPoints: MeteringPoint[]) {
    for (let mp of meteringPoints) {
      if (mp.id === id) {
        mp.selected = isSelected;
      }
    }
  }

  toggleAllMps() {
    let selectAll = !this.isAllMpsSelected();

    for (let mp of this.meteringPointsView) {
      mp.selected = selectAll;
    }
    this.selectedMeteringPoints = this.meteringPointsView.filter(mp => mp.selected);
  }

  foundInAdresses = (addresses: MeteringPointAddress[], filterString: string): boolean => {
    const matched = addresses.filter(address =>
      containsCaseInsensitive(address.street + ' ' + address.streetNo, filterString)
    );
    return matched.length > 0;
  };

  onSave() {
    this.dialogRef.close(this.selectedMeteringPoints);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
